import { LOCATION_CHANGE } from 'react-router-redux';
import { combineReducers } from 'redux';

export function activeID(state = 0, action) {
  switch (action.type) {
    case 'ADD_ACTIVE_AREA':
      return (action.area || {}).id || 0;
    default:
      return state;
  }
}

const createAreaReducer = layer => {
  return (state = [], { type, areas, polygons }) => {
    switch (type) {
      case `ADD_${layer.toUpperCase()}`:
        return [...areas].sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      case `ADD_${layer.toUpperCase()}_POLYGONS`: {
        const nextState = [...state];
        polygons.forEach(poly => {
          if (poly) {
            const farea = areas.find(ar => {
              if ((layer.toUpperCase() === 'REGIONS' || layer.toUpperCase() === 'COUNTIES') && ar.county_ids) {
                return ar.county_ids === poly.properties.StdGeographyID;
              }
              return ar.id === poly.properties.StdGeographyID;
            });
            const index = nextState.findIndex(s => s.id === farea.id);
            nextState[index] = {
              ...nextState[index],
              polygon: poly,
            };
          }
        });
        return nextState;
      }
      default:
        return state;
    }
  };
};

export const states = createAreaReducer('states');
export const counties = createAreaReducer('counties');
export const communities = createAreaReducer('communities');
export const regions = createAreaReducer('regions');

const overviewDefaults = {
  details: '',
  education: {},
  labor: {},
  population: {},
  populationByAge: {},
  futurePopulationByAge: {},
  malePopulationByAge: {},
  femalePopulationByAge: {},
  race: {},
  housing: {},
  industry: {},
  income: {},
  nationalIncome: {},
};

export function overview(state = overviewDefaults, { type, report, details }) {
  switch (type) {
    case 'ADD_AREA_REPORT':
      return { ...state, ...report };
    case 'ADD_AREA_DETAILS':
      return { ...state, details };
    default:
      return state;
  }
}

export function areasLoading(state = false, { type, loading = '' }) {
  switch (type) {
    case 'LOADING_STATES':
    case 'LOADING_REGIONS':
    case 'LOADING_COUNTIES':
    case 'LOADING_COMMUNITIES':
      return loading;
    default:
      return state;
  }
}

export function areaAll(state = {}, { type, areasAll }) {
  switch (type) {
    case 'AREA_ALL_DATA':
      return areasAll;
    default:
      return state;
  }
}

export function mapLayers(state = new Map(), action) {
  switch (action.type) {
    case 'RESET_AREAS_MAP':
      return new Map();
    case LOCATION_CHANGE:
      return new Map([...state]);
    case 'SET_AREAS_DEMOGRAPHIC':
      if (!action.field) {
        const next = new Map([...state]);
        next.delete('demographics');
        return next;
      }
      return new Map([...state, ['demographics', action.field]]);
    case 'SET_AREAS_WORKFORCE':
      if (!action.isActive) {
        const next = new Map([...state]);
        next.delete('workforce');
        return next;
      }
      return new Map([...state, ['workforce', true]]);
    case 'SET_AREAS_CUSTOM_LAYER':
      if (!action.layer) {
        const next = new Map([...state]);
        next.delete('customLayer');
        return next;
      }
      return new Map([...state, ['customLayer', action.layer]]);
    case 'SET_AREAS_PREDEFINED_LAYER':
      if (!action.layer) {
        const next = new Map([...state]);
        next.delete('predefinedLayer');
        return next;
      }
      return new Map([...state, ['predefinedLayer', action.layer]]);
    default:
      return state;
  }
}

export function businesses(state = null, action) {
  switch (action.type) {
    case 'SET_AREAS_NAICS_CODE_ERROR':
      return {
        naicsCode: action.naicsCode,
        error: action.error,
      };
    case 'SET_AREAS_NAICS_CODE':
      return {
        naicsCode: action.naicsCode,
        items: action.businesses,
      };
    case 'LOADING_AREAS_NAICS_CODE':
      return {
        loading: true,
        category: action.naicsCode,
      };
    default:
      return state;
  }
}


export default combineReducers({
  activeID,
  areaAll,
  areasLoading,
  states,
  counties,
  communities,
  regions,
  overview,
  mapLayers,
  businesses,
});



// WEBPACK FOOTER //
// ./src/store/reducers/areasReducers.js